import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Facebook domain verification — injected synchronously before React mounts
const meta = document.createElement('meta');
meta.name = 'facebook-domain-verification';
meta.content = 'gxzli5o5l1p61oulxmmkyg1i0v7iim';
document.head.appendChild(meta);
render(<App data-id="element-461" />, document.getElementById('root'));